
import { FaLandmark, FaWallet, FaRegGem, FaMoneyCheckAlt, FaCalendarAlt, FaChartLine, FaWrench, FaDog, FaCat, FaHorse, FaFish, FaDove } from 'react-icons/fa';

function getRandom(array) {
    return array[getRandomIntegerInInterval(0, array.length)]
}

function getRandomIntegerInInterval(min, max) {
    let difference = max - min;
    let rand = Math.random();

    rand = Math.floor(rand * difference);
    rand = rand + min;

    return rand;
}

export const routesNames = {
    base: {
        path:'/',
        title: 'Home',
    },
    termos: {
        termosDeUso: {
            path:'/termos-de-uso',
            title: 'Termos de uso',
        },
        politicaDePrivacidade: {
            path:'/politica-de-privacidade',
            title: 'Política de Privacidade',
        },
    },
    entrar: {
        path:'/entrar',
        title: 'Entrar',
    },
    cadastro: {
        novaConta: {
            path:"/nova-conta",
            title: "Nova Conta",
        },
        novoEstabelecimento: {
            path:"/novo-estabelecimento",
            title: "Novo Estabelecimento",
        },
    },
    purchaseProcess : {
        finishPurchase: {
            path:"/finalizar-pedido",
            title: "Finalizar pedido",
        }
    },
    estabelecimento: {
        index: '/estabelecimento/',
        agenda: {
            path:'/estabelecimento/agenda',
            title: 'Agenda', 
            icon: <FaCalendarAlt />,
        }, 
        servicos: {
            path:'/estabelecimento/servicos',
            title: 'Serviços',
            icon: <FaRegGem />,
        }, 
        loja: {
            path:'/estabelecimento/loja',
            title: 'Minha Loja',
            icon: <FaLandmark />,
        },
        financeiro: {
            path:'/estabelecimento/financeiro',
            title: 'Financeiro',
            icon: <FaMoneyCheckAlt />,
        },
        financial: {
            path:'/estabelecimento/dados-bancarios',
            title: 'Dados bancários',
            icon: <FaWallet />,
        }, 
        support: {
            path:'/estabelecimento/suporte',
            title: 'Suporte',
            icon: <FaWrench />,
        }, 
    },
    admin: {
        index: '/administrador/',
        metrics: {
            path:"/administrador/painel",
            title: "Métricas",
            icon: <FaChartLine />,
        },
        services: {
            path:"/administrador/servicos",
            title: "Serviços",
            icon: <FaRegGem />,
        },
        pups: {
            path:"/administrador/pups",
            title: "Classes de pups",
            icon: getRandom([<FaDog />, <FaCat />, <FaHorse />, <FaFish />, <FaDove />]),
        },
        ordersCanceled: {
            path:"/administrador/pedidos-cancelados",
            title: "Pedidos cancelados",
            icon: <FaChartLine />,
        },
        ordersExpired: {
            path:"/administrador/pedidos-expirados",
            title: "Pedidos expirados",
            icon: <FaChartLine />,
        },
    }
}
